import {OpenSummaryFilters} from '../../actions/inMemory/openSummary';

export default (state = false, action) => {
    const { type, ...data} = action;

    switch (type) {
        case OpenSummaryFilters.BOOLEAN:
            return data.bool;
        default:
            return state
    }
}
